import React from 'react';
import { cn } from '@/lib/utils';

interface ChatInputProps {
  textareaRef: React.RefObject<HTMLTextAreaElement>;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onKeyDown: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  onPaste: (event: React.ClipboardEvent) => void;
  onDrop: (event: React.DragEvent<HTMLTextAreaElement>) => void;
  minHeight: number;
  maxHeight: number;
}

export const ChatInput: React.FC<ChatInputProps> = ({
  textareaRef,
  value,
  onChange,
  onKeyDown,
  onPaste,
  onDrop,
  minHeight,
  maxHeight,
}) => {
  return (
    <textarea
      ref={textareaRef}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      onPaste={onPaste}
      onDragEnter={(e) => {
        e.preventDefault();
        e.currentTarget.style.border = '2px solid hsl(var(--primary))';
      }}
      onDragOver={(e) => {
        e.preventDefault();
        e.currentTarget.style.border = '2px solid hsl(var(--primary))';
      }}
      onDragLeave={(e) => {
        e.preventDefault();
        e.currentTarget.style.border = '1px solid hsl(var(--border))';
      }}
      onDrop={onDrop}
      placeholder="Как я могу помочь вам сегодня?"
      className={cn(
        "w-full rounded-lg border border-border",
        "bg-background text-foreground",
        "px-4 py-2 pr-20",
        "resize-none overflow-hidden",
        "focus-visible:ring-1 focus-visible:ring-ring",
        "placeholder:text-muted-foreground",
        "transition-all duration-200",
        "hover:border-primary",
        // Адаптивные стили
        "text-sm md:text-base",
        "min-h-[44px] md:min-h-[48px]",
        "max-h-[150px] md:max-h-[200px]"
      )}
      style={{
        minHeight,
        maxHeight
      }}
    />
  );
};